/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExceededLimitsDTO = {
    balanceLimitExceeded?: boolean;
    creditLimitExceeded?: boolean;
    debitLimitExceeded?: boolean;
    needsUpgradeToTier?: ExceededLimitsDTO.needsUpgradeToTier;
};

export namespace ExceededLimitsDTO {

    export enum needsUpgradeToTier {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

